<template>
  <div :class="getTabClass()">
    <div :class="getTabHeaderClass()">
      <a
        role="tab"
        class="p-accordion-header-link"
        :class="[selectAccordionType().tabheader, accordionTabColor]"
        @click="onTabClick"
        @keydown="onTabKeydown"
        :tabindex="disabled ? null : '0'"
        :aria-expanded="isTabActive()"
        :id="ariaId + '_header'"
        :aria-controls="ariaId + '_content'"
        style="text-decoration: none !important"
      >
        <div :class="[selectAccordionType().headerContent]">
          <div style="margin-right: 8px">
            <!-- <span :class="isTabActive() ? getHeaderCollapseIcon() : getHeaderExpandIcon()"></span> -->
            <i
              class="pi icon-technical-dropdown"
              style="width: 16px; height: 12px; background: #33d07c"
              :class="isTabActive() ? 'icon-down' : 'icon-right'"
            />
          </div>
          <div class="text-container">
            <span :class="[selectAccordionType().headerText]" v-if="header">{{
              header
            }}</span>
            <slot name="header"></slot>
          </div>
        </div>
      </a>
    </div>
    <transition name="p-toggleable-content">
      <div
        class="p-toggleable-content"
        v-show="isTabActive()"
        role="region"
        :id="ariaId + '_content'"
        :aria-labelledby="ariaId + '_header'"
      >
        <div class="p-accordion-content">
          <slot></slot>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import UniqueComponentId from "primevue/utils/UniqueComponentId";
import DomHandler from "primevue/utils/DomHandler";

export default {
  name: "AccordionTab",
  props: {
    header: null,
    disabled: Boolean,
    accordionType: {
      type: String,
      default: "normal", // Normal and Brillant
    },
    accordionTabColor: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      index: null,
    };
  },
  created() {
    this.$parent.$children.forEach((child, i) => {
      if (child === this) this.index = i;
    });
  },
  methods: {
    onTabClick(event) {
      if (!this.disabled) {
        this.$parent.onToggle(
          event,
          this,
          DomHandler.index(this.$el),
          this.isTabActive()
        );
      }
    },
    onTabKeydown(event) {
      if (event.which === 13) {
        this.onTabClick(event);
      }
    },
    isTabActive() {
      let activeArray = this.$parent.d_activeIndex;
      return this.$parent.multiple
        ? activeArray && activeArray.includes(this.index)
        : this.index === activeArray;
    },
    getTabClass() {
      return [
        this.selectAccordionType().accordionTab,
        { "p-accordion-tab-active": this.isTabActive() },
      ];
    },
    getTabHeaderClass() {
      return [
        "p-accordion-header",
        {
          "p-highlight": this.isTabActive(),
          "p-disabled": this.disabled,
          "p-accordion-header-custom": this.isTabActive(),
        },
      ];
    },
    getHeaderCollapseIcon() {
      return [
        "p-accordion-toggle-icon pi",
        this.$parent.collapseIcon,
        this.selectAccordionType().toggleIcon,
      ];
    },
    getHeaderExpandIcon() {
      return [
        "p-accordion-toggle-icon pi",
        this.$parent.expandIcon,
        this.selectAccordionType().toggleIcon,
      ];
    },
    selectAccordionType() {
      let res = {};
      switch (this.accordionType) {
        case "normal":
          res = {
            tabheader: this.isTabActive()
              ? "accordion-custom-1-activate"
              : "accordion-custom-1",
            headerContent: "accordion-header-content-1",
            headerText: "p-accordion-header-text-1",
            toggleIcon: "p-accordion-toggle-icon-1",
            accordionTab: "p-accordion-tab-normal",
          };
          return res;
          break;
        case "brillant":
          res = {
            tabheader: "accordion-custom-2",
            headerContent: "accordion-header-content-2",
            headerText: "p-accordion-header-text-2",
            toggleIcon: "p-accordion-toggle-icon-2",
            accordionTab: "p-accordion-tab",
          };
          return res;
          break;
        case "technical":
          res = {
            tabheader: "accordion-custom-3",
            headerContent: "accordion-header-content-3",
            headerText: "p-accordion-header-text-2",
            toggleIcon: "p-accordion-toggle-icon-2",
            accordionTab: "p-accordion-tab-technical",
          };
          return res;
          break;
        default:
      }
    },
  },
  computed: {
    ariaId() {
      return UniqueComponentId();
    },
  },
};
</script>
<style>
.accordion-custom-1 {
  background: #ffffff 0% 0% no-repeat padding-box !important;
  border-radius: 15px !important;
  border: 1px solid #ffffff !important;
  height: 56px !important;
  box-shadow: 0px 3px 6px #cccccc80 !important;
}
.accordion-custom-1-activate {
  background: #f4f4f4 0% 0% no-repeat padding-box !important;
  border-radius: 15px !important;
  border: 1px solid #f4f4f4 !important;
  height: 56px !important;
  box-shadow: none !important;
}
.accordion-custom-2 {
  background: var(--iu-font3) 0% 0% no-repeat padding-box !important;
  border-radius: 0px !important;
  border: 1px solid var(--iu-font3) !important;
  height: 47px;
}
.accordion-custom-3 {
  background: #ffffff 0% 0% no-repeat padding-box !important;
  border-radius: 0px !important;
  border: 1px solid #ffffff !important;
  height: 40px;
}
.p-accordion-header-custom {
  background: var(--iu-font2) 0% 0% no-repeat padding-box !important;
  border-top-left-radius: 15px !important;
  border-top-right-radius: 15px !important;
  border-bottom-right-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
  border-right: 1px solid var(--iu-font3) !important;
  border-left: 1px solid var(--iu-font3) !important;
}

.p-accordion .p-accordion-tab {
  margin-bottom: 16px !important;
}
.p-accordion-content {
  background: var(--iu-font2) 0% 0% no-repeat padding-box !important;
  border-bottom-right-radius: 15px !important;
  border-bottom-left-radius: 15px !important;
  padding: 19px 24px 19px 16px !important;
  border: 1px solid var(--iu-font2) !important;
}
.accordion-header-content-1 {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.accordion-header-content-2 {
  display: flex;
  justify-content: space-between;
}
.accordion-header-content-3 {
  display: flex;
  justify-content: space-between;
}
.p-accordion-header-text-1 {
  color: #0a3c45;
  font-size: 20px;
  font-family: var(--font-acumin-pro-semibold);
  color: var(--iu-secondary);
  letter-spacing: 0px;
}
.p-accordion-header-text-2 {
  color: #0a3c45;
  font-size: 18px;
  font-family: var(--font-acumin-pro-semibold);
  color: var(--iu-secondary);
  letter-spacing: 0px;
  margin-right: 8px;
}
.p-accordion-toggle-icon-1 {
  font-size: 32px !important;
  margin-right: 0rem !important;
  color: var(--iu-secondary);
}
.p-accordion-toggle-icon-2 {
  font-size: 16px !important;
  margin-right: 0rem !important;
  color: var(--iu-main);
  top: 2px;
  position: relative;
  margin: auto;
}
.text-container {
  margin: auto;
  width: 100%;
}
.p-accordion-header {
  a {
    text-decoration: none !important;
  }
}
.mb-tab-0 {
  .p-accordion,
  .p-accordion-tab {
    margin-bottom: 0px !important;
  }
}
.secondary-tab-color {
  background: var(--iu-font2) 0% 0% no-repeat padding-box !important;
  border: 1px solid var(--iu-font2) !important;
}
.p-accordion-tab-technical {
  .p-accordion-header {
    border-right: 0px solid var(--iu-font3) !important;
    border-left: 0px solid var(--iu-font3) !important;
    .p-accordion-header-link {
      padding: 8px 0px 8px 0px !important;
      border: 0px solid #ffffff !important;
    }
    .p-accordion-header-link:focus {
      outline: none;
      outline-offset: 0;
      box-shadow: 0 0 0 0 white !important;
    }
  }
  .p-toggleable-content {
    .p-accordion-content {
      background: #ffffff !important;
      padding: 19px 0px 19px 0px !important;
      border: 0px solid var(--iu-font2) !important;
    }
  }
}

.p-accordion-tab-normal {
  .p-accordion-header {
    .p-accordion-header-link {
      padding: 8px 8px 8px 16px !important;
    }
  }
  margin-bottom: 16px !important;
  .p-toggleable-content {
    .p-accordion-content {
      background: #ffffff !important;
      border-top: 0px !important;
      border-right: 1px solid #cccccc80 !important;
      border-left: 1px solid #cccccc80 !important;
      border-bottom: 1px solid #cccccc80 !important;
      padding: 24px 16px 24px 16px !important;
    }
  }
}

.icon-down {
  transform: rotate(0deg);
  transition-duration: 0.5s;
}

.icon-right {
  transform: rotate(-90deg);
  transition-duration: 0.5s;
}
</style>
